import React from 'react';
import LeavePolicyGenericWithAllotmentStep from '@/components/attendance/admin/wizard/shared/LeavePolicyGenericWithAllotmentStep';
import { WizardStepProps } from '@/components/attendance/admin/wizard/useLeavePoliciesWizard';

export default function LeavePolicyParentalStep01(props: WizardStepProps) {
  return <LeavePolicyGenericWithAllotmentStep type="parental" {...props} />;
}
